import * as $ from 'jquery';
import * as countryStateSetup from '../modules/countryStateSetup';
import * as fileInput from '../modules/fileInput';
import * as finishSelector from '../modules/finishSelector';
import * as formValidation from '../modules/formValidation';
import TranslationsService from '../services/translationsService';
import 'url-search-params-polyfill';

declare const grecaptcha: any;

namespace PFF.controllers.askAQuestion {

	// Init translations service
	const translationsService = TranslationsService.getInstance();
	let translationStrings = JSON.parse($("#translations").html());
	translationsService.init(translationStrings);

	let $form = $('form');
	let $aaqForm = $('#aaq-form');
	let $alertSuccess = $('.js-alert-success');
	let $alertDanger = $('.js-alert-danger');
	let $alertDangerFields = $('.js-alert-danger-fields');
	let $errorList = $('.js-issues-need-correction');
	let $firstName = $('#first-name');
	let $lastName = $('#last-name');
	let $email = $('#email');
	let $emailConfirm = $('#email-confirm');
	let $address = $('#address');
	let $address2 = $('#address2');
	let $country = $('#country');
	let $city = $('#city');
	let $stateProvince = $('#state-province');
	let $postalCode = $('#postal-code');
	let $phone = $('#phone');
	let $helpCategory = $('[name="help-category"]');
	let $originalOwner = $('[name="original-owner"]');
	let $productCategory = $('#product-category');
	let $finish = $('#finish');
	let $model = $('#model');
	let $purchaseYear = $('#purchase-year');
	let $questionComment = $('#question-comment');
	let $uploadPhoto = $('#upload-photo');
	let $gdprConsent = $('#gdpr-consent');
	let $troubleshootingCategory = $('#trouble-shooting-category');
	let $troubleshootingTopic = $('#trouble-shooting-topic');
	let $submit = $('#submit');
	let $pleaseWait = $('#please-wait');	
	let $loadIndicator = $('.js-load-indicator');
	let $generalInquiry = $('.js-general-inquiry');
	let uploadPhotoTranslation = translationsService.translate('FormValidationErrors.UploadPhotoRequired');
	let uploadFiles = [];

	let constraints = {
		'first-name': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.FirstNameRequired')
			}
		},
		'last-name': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.LastNameRequired')
			}
		},
		email: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.EmailRequired')
			},
			email: {
				message: '^' + translationsService.translate('FormValidationErrors.EmailInvalid')
			}
		},
		'email-confirm': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.ConfirmEmailRequired')
			},
			equality: {
				attribute: 'email',
				message: '^' + translationsService.translate('FormValidationErrors.ConfirmEmailInvalid')
			}
		},
		address: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.AddressRequired')
			}
		},
		address2: {
			presence: false
		},
		country: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CountryRequired')
			}
		},
		city: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CityRequired')
			}
		},
		'state-province': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.StateRequired')
			}
		},
		'postal-code': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PostalCodeRequired')
			}
		},
		phone: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PhoneRequired')
			},
			format: {
				pattern: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
				message: '^' + translationsService.translate('FormValidationErrors.PhoneInvalid')
			}
		},
		'original-owner': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.OriginalOwnerRequired')
			}
		},
		'product-category': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.ProductCategoryRequired')
			}
		},
		'finish': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.FinishRequired')
			}
		},
		'purchase-year': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PurchaseYearRequired')
			},
			numericality: {
				onlyInteger: true,
				greaterThan: 0,
				message: '^' + translationsService.translate('FormValidationErrors.PurchaseYearInvalid')
			}
		},
		'help-category': {
			presence: {
				message: '^' + translationsService.translate('FormValidationErrors.HelpCategoryRequired')
			}
		},
		'question-comment': {
			presence: false
		},
		'gdpr-consent': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PrivacyPolicyRequired')
			}
		},
		'recaptcha-token': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CaptchaRequired')
			}
		}
	};


	let constraintsGeneral = {
		'first-name': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.FirstNameRequired')
			}
		},
		'last-name': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.LastNameRequired')
			}
		},
		email: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.EmailRequired')
			},
			email: {
				message: '^' + translationsService.translate('FormValidationErrors.EmailInvalid')
			}
		},
		'email-confirm': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.ConfirmEmailRequired')
			},
			equality: {
				attribute: 'email',
				message: '^' + translationsService.translate('FormValidationErrors.ConfirmEmailInvalid')
			}
		},
		address: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.AddressRequired')
			}
		},
		address2: {
			presence: false
		},
		country: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CountryRequired')
			}
		},
		city: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CityRequired')
			}
		},
		'state-province': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.StateRequired')
			}
		},
		'postal-code': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PostalCodeRequired')
			}
		},
		phone: {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PhoneRequired')
			},
			format: {
				pattern: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
				message: '^' + translationsService.translate('FormValidationErrors.PhoneInvalid')
			}
		},
		'help-category': {
			presence: {
				message: '^' + translationsService.translate('FormValidationErrors.HelpCategoryRequired')
			}
		},
		'question-comment': {
			presence: false
		},
		'gdpr-consent': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.PrivacyPolicyRequired')
			}
		},
		'recaptcha-token': {
			presence: {
				allowEmpty: false,
				message: '^' + translationsService.translate('FormValidationErrors.CaptchaRequired')
			}
		}
	};

	let validateField = function () {
		$(this).addClass('dirty');
		if (formValidation.validateWrapper({
			constraints: $generalInquiry.is(":checked") ? constraintsGeneral : constraints,
			values: {
				'first-name': $firstName.val(),
				'last-name': $lastName.val(),
				email: $email.val(),
				'email-confirm': $emailConfirm.val(),
				address: $address.val(),
				address2: $address2.val(),
				country: $country.val(),
				city: $city.val(),
				'state-province': $stateProvince.val(),
				'postal-code': $postalCode.val(),
				phone: $phone.val(),
				'original-owner': $originalOwner.filter(':checked').val(),
				'product-category': $productCategory.val(),
				'finish': $finish.val(),
				'model': $model.val(),
				'purchase-year': $purchaseYear.val(),
				'help-category': $helpCategory.filter(':checked').val(),
				'question-comment': $questionComment.val(),
				'gdpr-consent': $gdprConsent.prop('checked') ? 1 : undefined,
				'recaptcha-token': grecaptcha.getResponse()
			}
		})) {
			// disable submit button
		}
	};

	let setupHandlers = function () {
		//waiting a second here so that the fileinput.ts binding that happens can be turned off.
		setTimeout(function () {
			$('input[type=file]').off('change.file');
			$('#upload-photo').on('change.upload', function (e) {
				var $value = $(this).siblings('.js-file-input-value');
				var $this = $(this);
				if (this.files && this.files[0]) {
					if (e.target.files.length <= 5) {
						uploadFiles = [];
						var output = [];
						for (var i = 0; i < e.target.files.length; i++) {
							uploadFiles.push(e.target.files[i]);
							let removeLink = '<i data-fileid=\"' + i + '\" class="icon icon-close file-input-close js-remove-file" title="Remove Image"></i>';
							output.push('<li><strong>' + e.target.files[i].name + '</strong>' + removeLink + '</li> ');
						}
						$value.html('');
						$value.append(output.join(""));
						if ($this.data("accept")) {
							let fileAssocArray = $this.data("accept").split(',');
							for (var i = 0; i < e.target.files.length; i++) {
								let fileName = e.target.files[i].name;
								let fileExt = (fileName.split(/[. ]+/).pop()).toLowerCase();
								if (fileAssocArray.indexOf(`.${fileExt}`) > -1) {
									validateField();
								}
								else {
									$value.html('');
									alert(`.${fileExt} files are not allowed. Please choose one of the following file types: (${fileAssocArray})`);
								}
							}
						}
					}
					else {
						alert(`Cannot upload more than 5 files`);
					}
				} else {
					$value.html('');
				}
			});
		}, 1000);

		$('body').on('click.register', '.js-reset-file', function (e) {
			validateField();
			e.preventDefault();
		});

		// remove clicked file
		$('body').on('click.register', '.js-remove-file', function (e) {
			e.preventDefault();
			var fileName = $(this).parent().children("strong").text();
			for (let i = 0; i < uploadFiles.length; ++i) {
				if (uploadFiles[i].name == fileName) {
					uploadFiles.splice(i, 1);
				}
			}
			$(this).parent().remove();
		});


		//show/hide my question relates to
		$('body').on('change', 'input[type="radio"][name="help-category"]', function () {
			var $productInformation = $('.js-product-info');
			if ($generalInquiry.is(':checked')) {
				$productInformation.addClass('hidden');
			} else {
				$productInformation.removeClass('hidden');
			}
		});
	};

	let trackAskQuestionSubmit = function () {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
			'event' : 'ask_a_question_submitted'
		});
		console.log(window.dataLayer);
	};

	let inputEventListeners = function () {
		$firstName.on('blur change', validateField);
		$lastName.on('blur change', validateField);
		$email.on('blur change', validateField);
		$emailConfirm.on('blur change', validateField);
		$address.on('blur change', validateField);
		$address2.on('blur change', validateField);
		$country.on('blur change', validateField);
		$city.on('blur change', validateField);
		$stateProvince.on('blur change', validateField);
		$postalCode.on('blur change', validateField);
		$phone.on('blur change', validateField);
		$originalOwner.on('blur change', validateField);
		$productCategory.on('blur change', validateField);
		$purchaseYear.on('blur change', validateField);
		$helpCategory.on('blur change', validateField);
		$questionComment.on('blur change', validateField);
		$gdprConsent.on('blur change', validateField);
		grecaptcha.ready(() => {
			grecaptcha.render( document.getElementById('g-recaptcha'), {
				callback: validateField
			});
		});
	};

	let submitEventListener = function () {
		$submit.on('click', function (e) {
			e.preventDefault();

			$submit.addClass('hidden');
			$pleaseWait.removeClass('hidden');

			$('.js-alert').addClass('hidden');		
			let fileHasValue: boolean = uploadFiles && uploadFiles.length > 0;

			if (formValidation.validateWrapperSubmit({
				constraints: $generalInquiry.is(":checked") ? constraintsGeneral : constraints,
				values: {
					'first-name': $firstName.val(),
					'last-name': $lastName.val(),
					email: $email.val(),
					'email-confirm': $emailConfirm.val(),
					address: $address.val(),
					address2: $address2.val(),
					country: $country.val(),
					city: $city.val(),
					'state-province': $stateProvince.val(),
					'postal-code': $postalCode.val(),
					phone: $phone.val(),
					'original-owner': $originalOwner.filter(':checked').val(),
					'product-category': $productCategory.val(),
					'finish': $finish.val(),
					'model': $model.val(),
					'purchase-year': $purchaseYear.val(),
					'help-category': $helpCategory.filter(':checked').val(),
					'question-comment': $questionComment.val(),
					'gdpr-consent': $gdprConsent.prop('checked') ? 1 : undefined,
					'recaptcha-token': grecaptcha.getResponse()
				}
			}) && ((fileHasValue === true && !$generalInquiry.is(":checked")) || $generalInquiry.is(":checked")) ) {
			// Do nothing if ok
			} else {
				if(fileHasValue === false && !$generalInquiry.is(":checked")) {
					$(`<li>${uploadPhotoTranslation}</li>`).appendTo($errorList);
				}
				$alertDangerFields.removeClass('hidden');
				$("html, body").animate({ scrollTop: 0 }, 500);				
				$submit.removeClass('hidden');
				$pleaseWait.addClass('hidden');
				return;
			}
			$("html, body").animate({ scrollTop: 0 }, 500);
            $loadIndicator.addClass('state-loading');

			let data = new FormData();

			let contactInfo = JSON.stringify({
				FirstName: $firstName.val(),
				LastName: $lastName.val(),
				Email: $email.val(),
				Address1: $address.val(),
				Address2: $address2.val(),
				Country: $country.val(),
				City: $city.val(),
				State: $stateProvince.val(),
				PostalCode: $postalCode.val(),
				Phone: $phone.val()
			});

			data.append("ContactInfo", contactInfo);
			data.append("HelpCategory", $helpCategory.filter(':checked').val());
			data.append("OriginalOwner", $originalOwner.filter(':checked').val());
			data.append("Question", $questionComment.val());
			data.append("Product", $productCategory.val());
			data.append("PurchaseYear", $purchaseYear.val());
			data.append("Finish", $finish.val());
			data.append("Model", $model.val());
			data.append("File", fileInput.fileAtIndex($uploadPhoto[0], 0));
			data.append("GdprConsent", $gdprConsent.val());
			data.append("SubProduct", $troubleshootingCategory.val());
			data.append("TroubleshootingTopic", $troubleshootingTopic.val());

			$.ajax({
				url: '/api/salesforce/post-ask-a-question',
				type: 'POST',
				dataType: 'json',
				data: data,
				processData: false,
				contentType: false // not json
			})
				.done(function (data) {
					// upload files
					if(uploadFiles.length >0)
					{
						getCaseKeyForFileUpload(data.CaseNumber);
					}
					
					$alertSuccess.removeClass('hidden');
					$aaqForm[0].reset();
					formValidation.resetForm($form);
					$('.js-file-input-value').text('');
					$('#case-number').text(data.CaseNumber)
					trackAskQuestionSubmit();
				})
				.fail(function (response) {
					console.log(response);
					$alertDanger
						.removeClass('hidden')
						.find('.alert__text').text(response.responseJSON.Message);
				})
				.always(function () {
					$("html, body").animate({ scrollTop: 0 }, 500);	
					$loadIndicator.removeClass('state-loading');			
					$submit.removeClass('hidden');
					$pleaseWait.addClass('hidden');
				})
		});
	};

	let getCaseKeyForFileUpload = function (caseNumber) {
		let data = {
			email: $email.val(),
			caseNumber: caseNumber,
		};
		$.get('/api/salesforce/get-case-id', data)
			.done(function (data) {
				uploadCaseFiles(data);
			})
			.fail(function (response: any) {
				console.log(response);
				$alertDanger
					.removeClass('hidden')
					.find('.js-alert-text')
					.text('Error getting case info to upload documents');
			})
	};

	let uploadCaseFiles = function (caseKey) {
		let data = new FormData();
		data.append("Id", caseKey);
		data.append("Comment", "");

		for (var i = 0; i < uploadFiles.length; i++)
			data.append("Files" + i, uploadFiles[i]);

		$.ajax({
			url: '/api/salesforce/upload-file',
			type: 'POST',
			dataType: 'json',
			data: data,
			processData: false,
			contentType: false // not json
		})
			.done(function () {
				console.log('case files uploaded');
			})
			.fail(function (response) {
				$alertDanger
					.removeClass('hidden')
					.find('.alert__text').text("Error uploading files");
			})

	};

	let setHiddenInputs = function () {
		// This may need a polyfill or fallback it is not supported in IE11
		let urlParams = new URLSearchParams(window.location.search);
		let helpCategoryParam = urlParams.get('helpCategory');
		$troubleshootingCategory.val(urlParams.get('subProduct'));
		$troubleshootingTopic.val(urlParams.get('troubleshootingTopic'));
		$model.val(urlParams.get('modelNumber'));

		//precheck the HelpCategory 'My question relates to:'
		$('input[name=help-category]').each(function(index) {
			if ( helpCategoryParam === $(this).val() ) {
				$(this).attr('checked', true);
			}
		});
	};

	export function init() {
		setupHandlers();
		countryStateSetup.init($country, $stateProvince);
		fileInput.init();
		finishSelector.init();
		setHiddenInputs();
		inputEventListeners();
		submitEventListener();
	}
}

PFF.controllers.askAQuestion.init();



// WEBPACK FOOTER //
// ./js/PFF/controllers/askAQuestion.ts